type DateFormat = 'SHORT' | 'LONG'; // SHORT = MM/DD/YYYY or dependent on locale, LONG = Mon DD, YYYY

export const formatDate = (
  dateString?: string,
  locale: string = 'en-US',
  format: DateFormat = 'SHORT'
): string => {
  const date = getDate(dateString);
  if (!date) return '';

  switch (format) {
    case 'LONG':
      return date.toLocaleDateString(locale, {
        year: 'numeric',
        month: 'short', // Oct
        day: 'numeric', // 4
      });

    case 'SHORT':
    default:
      return date.toLocaleDateString(locale, {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric',
      });
  }
};

export const formatDateYMD = (dateString?: string): string => {
  const date = getDate(dateString);
  if (!date) {
    return '';
  }
  return `${date.getFullYear().toString().padStart(4, '0')}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;
};

function getDate(dateString?: string): Date | null {
  if (!dateString) {
    return null;
  }

  let date;
  // Handle Sitecore specific format '20250329T000000' by adding dashes
  if (/^\d{8}T\d{6}/.test(dateString)) {
    const year = dateString.substring(0, 4);
    const month = dateString.substring(4, 6);
    const day = dateString.substring(6, 8);
    date = new Date(`${year}-${month}-${day}`);
  } else {
    date = new Date(dateString);
  }
  const timestamp = date.getTime();
  // 1900-01-01T00:00:00Z in ms since epoch
  const minTimestamp = -2208988800000;

  const isValidDate = !isNaN(timestamp) && timestamp >= minTimestamp;
  if (!isValidDate || isNaN(date.getTime())) {
    return null;
  }
  return date;
}

export const sitecoreDateToIsoWithOffset = (
  sitecoreDate?: string,
  offset: string = '+08:00'
): string => {
  if (!sitecoreDate) return '';
  const y = sitecoreDate.slice(0, 4);
  const m = sitecoreDate.slice(4, 6);
  const d = sitecoreDate.slice(6, 8);
  const h = sitecoreDate.slice(9, 11);
  const min = sitecoreDate.slice(11, 13);
  const s = sitecoreDate.slice(13, 15);
  const utcDate = new Date(`${y}-${m}-${d}T${h}:${min}:${s}Z`);
  const sign = offset[0] === '-' ? -1 : 1;
  const offsetMinutes = sign * (Number(offset.slice(1, 3)) * 60 + Number(offset.slice(4, 6)));
  const localDate = new Date(utcDate.getTime() + offsetMinutes * 60000);
  const pad = (n: number) => n.toString().padStart(2, '0');
  return (
    `${localDate.getFullYear()}-` +
    `${pad(localDate.getMonth() + 1)}-` +
    `${pad(localDate.getDate())}T` +
    `${pad(localDate.getHours())}:` +
    `${pad(localDate.getMinutes())}:` +
    `${pad(localDate.getSeconds())}` +
    offset
  );
};
export default formatDate;
